import { Controller } from "@hotwired/stimulus"

// Mirrors PettyCash::Receipt.recoverable_by_default? so the person entering the
// receipt sees, before they submit, whether the VAT can be reclaimed and why
// not when it cannot. The server decides — this only explains the decision.
//
// Kept in step with BLOCKED_CATEGORIES in app/models/petty_cash/receipt.rb.
const BLOCKED_CATEGORIES = ["food_refreshments"]

export default class extends Controller {
  static targets = ["category", "vat", "trn", "override", "verdict", "reason", "notice"]

  connect() {
    this.refresh()
  }

  refresh() {
    const vat = parseFloat(this.vatTarget.value) || 0
    const trn = this.trnTarget.value.trim()
    const blocked = BLOCKED_CATEGORIES.includes(this.categoryTarget.value)

    let reason = null
    if (vat <= 0) reason = "No VAT entered, so there is nothing to reclaim."
    else if (!trn) reason = "No supplier TRN — without a tax invoice the VAT stays in the cost."
    else if (blocked) reason = "Entertainment (VAT Art. 53) — input tax is blocked. Tick only if your accountant confirms it is recoverable."

    const recoverable = reason === null
    this.overrideTarget.checked = recoverable
    this.overrideTarget.disabled = vat <= 0 || !trn
    this.verdictTarget.textContent = recoverable
      ? "Reclaim the VAT on this receipt"
      : "VAT will stay in the expense"
    this.reasonTarget.textContent = reason || "A valid tax invoice, so the VAT goes to 1220 and into the return."
  }
}
